import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import UserFamilyRemoveInvitation from './UserFamilyRemoveInvitation';

loadDOMComponent({
	selector: 'react-user-family-member-remove-invitation',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const onConfirm = container.getAttribute('onConfirm');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<UserFamilyRemoveInvitation onConfirm={onConfirm} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
